import { NotifyHelper } from "../../../helpers/toast";
import { eDmCoSoActionsObj } from "../../action-types/category/IDmCoSoActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const coSoActions = {
  ...generateActions(eDmCoSoActionsObj, "CO_SO"),
  ...generateActionForKey(eDmCoSoActionsObj, "CO_SO", "SAVE_SUCCESS", () => {
    NotifyHelper.Success("Thành công");
  }),
  ...generateActionForKey(eDmCoSoActionsObj, "CO_SO", "DELETE_SUCCESS", () => {
    NotifyHelper.Success("Thành công");
  }),
  ...generateActionForKey(eDmCoSoActionsObj, "CO_SO", "SAVE_ERRR", (m) => {
    NotifyHelper.Error(m);
  }),
  ...generateActionForKey(eDmCoSoActionsObj, "CO_SO", "DELETE_ERRR", (m) => {
    NotifyHelper.Error(m);
  }),
};
